import { render, staticRenderFns } from "./Comparison.vue?vue&type=template&id=023de0cd"
import script from "./Comparison.vue?vue&type=script&lang=js"
export * from "./Comparison.vue?vue&type=script&lang=js"
import style0 from "./Comparison.vue?vue&type=style&index=0&id=023de0cd&prod&lang=css"
import style1 from "./Comparison.vue?vue&type=style&index=1&id=023de0cd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports